import React from 'react';
import { useScrollReveal } from '../../hooks/useGSAP';
interface AnimatedSectionProps {
  children: ReactNode;
  className?: string;
  delay?: number;
}
export function AnimatedSection({
  children,
  className = '',
  delay = 0
}: AnimatedSectionProps) {
  const ref = useScrollReveal();
  return <section ref={ref as React.RefObject<HTMLElement>} className={className} style={{
    transitionDelay: `${delay}ms`
  }} data-id="element-86">
      {children}
    </section>;
}